<script lang="ts">
  import FicheCarteEmis from '@/generated/fiches/FicheCarteEmis.vue';
  import { defineComponent } from "vue";
  import Delivery from '@/extend/classes/Delivery';
  import Transaction from '@/extend/classes/Transaction';

  export default defineComponent({
    components: {},
    extends: FicheCarteEmis,
    computed: {      
      selectedTransaction(): Transaction {
        if (this.transaction) {
          return this.transaction;
        } else {
          return new Transaction();
        }
      },
    }, methods: {
      selectItem(item: Delivery): void {
        this.transaction.deliveryId = item.id;
      }
    }
  })

</script>
